<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('taskName1')">
          <Input clearable v-model="taskName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('subtaskName1')">
          <Input clearable v-model="subtaskName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('workDate1')" style="margin-right: 100px;">
          <el-date-picker v-model="workTime" :editable="true" clearable type="daterange" value-format="yyyy-MM-dd" :start-placeholder="$t('beginTime')" 
            :end-placeholder="$t('endTime')" style="width: 250px;"></el-date-picker>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchLabourHourByPage">{{$t('search')}}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-download" @click="exportExcel">{{$t('export')}}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-plus" v-if="showAdd" @click="addInfo">{{$t('add')}}</el-button>
        </div>
      </Form>
      <div class="contentTableDiv">
        <el-table :data="hourTotal" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="workContent" :label="$t('hourEntry')" align="center" :show-overflow-tooltip="true" min-width="110"></el-table-column>
          <el-table-column prop="workHours" :label="$t('workSummary')" align="center" :show-overflow-tooltip="true" min-width="110"></el-table-column>
          <el-table-column prop="travelHours" :label="$t('travelSummary')" align="center" :show-overflow-tooltip="true" min-width="130"></el-table-column>
          <el-table-column prop="workDescribe" :label="$t('totalHours')" align="center" :show-overflow-tooltip="true" min-width="110" ></el-table-column>
        </el-table>
      </div>
      <div class="contentTableDiv">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" v-if="false"></el-table-column> 
          <el-table-column prop="workContent" :label="$t('workContent')" align="left" :show-overflow-tooltip="true" min-width="250">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.workContent}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="workDescribe" :label="$t('workDescribe')" align="center" :show-overflow-tooltip="true" min-width="180"></el-table-column>
          <el-table-column prop="workHours" :label="$t('workHours')" align="center" :show-overflow-tooltip="true" min-width="110"></el-table-column>
          <el-table-column prop="travelHours" :label="$t('travelHours')" align="center" :show-overflow-tooltip="true" min-width="130"></el-table-column>
          <el-table-column prop="workDate" :label="$t('workDate')" width="150" align="center"></el-table-column>
          <el-table-column prop="subtaskName" :label="$t('subtaskName')" align="left" :show-overflow-tooltip="true" min-width="200">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskName}}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('operate')" fixed="right" width="160" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.flagStatus=='0'" size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button>
              <el-button v-if="scope.row.flagStatus=='0'" size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'

    export default {
        name: 'labourEngineer',
        activated () {
          let lEngineer = this.$route.params.indexTolEngineer;
          if(lEngineer == 'N' || JSON.stringify(this.$route.params)=='{}'){
            this.getLabourHourByPage();
          }
        },
        created () {
          // this.getParams();
          this.getLabourHourByPage();
        },
        data () {
          return {
            rangeNumber: 10,
            taskName:null,
            subtaskName:null,
            workTime:[],
            //other
            showAdd:false,
            exportLoading:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            tableData: [],
            hourTotal: [],
          }
        },
        methods: {
          getParams(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
              let params = this.$route.params;
              this.currentPage = params.currentPage;
              this.pageSize = params.pageSize;
              this.taskName = params.taskName;
              this.subtaskName = params.subtaskName;
              this.workTime = params.workTime;
            }
          },
          getLabourHourByPage(){
            let projectId = this.$route.params.projectNumber;
            if(projectId != undefined && projectId != null && projectId != ''){
              this.projectNumber = projectId;
            }
            let taskId = this.$route.params.taskNumber;
            if(taskId != undefined && taskId != null && taskId != ''){
              this.taskNumber = taskId;
            }
            let subtaskId = this.$route.params.subtaskNumber;
            if(subtaskId != undefined && subtaskId != null && subtaskId != ''){
              this.subtaskNumber = subtaskId;
            }
            let homeDate = this.$route.params.homeDate;
            if(homeDate != undefined && homeDate != null && homeDate.length == 2){
              this.workTime = homeDate;
            }
            let workTime1 = null,workTime2 = null;
            if(this.workTime != null && this.workTime != '' && this.workTime.length > 0){
              workTime1 = this.workTime[0];
              workTime2 = this.workTime[1];
            }
            let url = `${this.$store.state.islhurl}getLabourHourInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskId: this.taskNumber==''?null:this.taskNumber,
              subtaskId: this.subtaskNumber==''?null:this.subtaskNumber,
              workTime1: workTime1,
              workTime2: workTime2,
              taskName: this.taskName==''?null:this.taskName,
              subtaskName: this.subtaskName==''?null:this.subtaskName,
              labourStatus: 'engineer',
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.hourTotal = res.hourTotal;
                this.tableData = res.data;
                this.totalCount = res.totalNums;
                if(homeDate != undefined && homeDate != null && homeDate.length == 2){
                  let selectDate = homeDate[0];
                  let currDate = this.timeFormat(new Date());
                  let lastDate = res.sdate;
                  if(selectDate <= currDate && selectDate >= lastDate){
                    this.showAdd = true;
                  }else{
                    this.showAdd = false;
                  }
                }
              }
            )
          },
          searchLabourHourByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let workTime1 = null,workTime2 = null;
            if(this.workTime != null && this.workTime != '' && this.workTime.length > 0){
              workTime1 = this.workTime[0];
              workTime2 = this.workTime[1];
            }
            let url = `${this.$store.state.islhurl}getLabourHourInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskId: this.taskNumber==''?null:this.taskNumber,
              subtaskId: this.subtaskNumber==''?null:this.subtaskNumber,
              workTime1: workTime1,
              workTime2: workTime2,
              taskName: this.taskName==''?null:this.taskName,
              subtaskName: this.subtaskName==''?null:this.subtaskName,
              labourStatus: 'engineer',
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.hourTotal = res.hourTotal;
                this.tableData = res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          handleNavigation(index){
            let pm = {
              id: index.id,
              showRun:'Y',
              returnF: 'Y',
            }
            this.$router.push({name:'labour_detail',params:pm})
          },
          handleEdit(index) {
            let pm = {
              id: index.id,
              taskId: index.taskId,
              returnF: 'Y',
            }
            this.$router.push({name:'labour_edit',params:pm})
          },
          handleSubtask(index){
            let pm = {
              subtaskNumber: index.subtaskId,
            }
            this.$router.push({name:'subtask_detail',params:pm});
          },
          handleDelete(index){
            this.$confirm("Are you sure to delete the labour hour", "Warning", {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              let params = {
                id:index.id,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}labourHour/deleteInfo`
              this._post(url,params).then(
                res =>{
                  if(res=="200"){
                    this.getLabourHourByPage();
                    this.$Message.success('Labour Hour Delete Successful' )
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            }).catch(() => {
            });
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'LabourHourInfo.xlsx';
            const length = this.multipleSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            let workTime1 = null,workTime2 = null;
            if(this.workTime != null && this.workTime != '' && this.workTime.length > 0){
              workTime1 = this.workTime[0];
              workTime2 = this.workTime[1];
            }
            this.$axios({
              url: `${this.$store.state.islhurl}labourHour/exportInfo`,
              method: 'post',
              data: {
                ids: ids,
                projectId: this.projectNumber==''?null:this.projectNumber,
                taskId: this.taskNumber==''?null:this.taskNumber,
                subtaskId: this.subtaskNumber==''?null:this.subtaskNumber,
                workTime1: workTime1,
                workTime2: workTime2,
                taskName: this.taskName==''?null:this.taskName,
                subtaskName: this.subtaskName==''?null:this.subtaskName,
                labourStatus: 'engineer',
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          addInfo() {
            if(this.workTime == null || this.workTime[0].length == 0){
              this.$Message.error("Please select Work Date");
              return;
            }
            let pm = {
              wkTime: this.workTime[0],
              lEngineerTolEnter: 'N',
            }
            this.$router.push({name:'labourEnter',params:pm});
            this.$store.commit('tagChange', 'labourEnter');
          },
          changePage (val) {
            this.currentPage = val;
            this.getLabourHourByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getLabourHourByPage();
          },
          timeFormat (time) {
            if(time == null || time == ""){
              return null;
            }
            const dateTime = new Date(time);
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth() + 1;
            const date = dateTime.getDate();
            return year + "-" + this.addZero(month) + "-" + this.addZero(date);
          },
          addZero (v) {
            return v < 10 ? '0' + v : v;
          }
        },
    }
</script>



// WEBPACK FOOTER //
// src/view/labour/labourEngineer.vue